<template>
	<v-combobox multiple
        v-model="recipients"
        :items="employeesMapped"
        item-text="name"
        item-value="id"
        label="Recipients" 
        append-icon
        chips
        deletable-chips
        return-object
        class="tag-input"
        :search-input.sync="search" 
        :menu-props="{ closeOnClick: false, closeOnContentClick:true, openOnClick:false, maxHeight:300}"
        @change="updateRecipients"
        >

        <template v-slot:selection="data">

            <v-chip v-if="typeof data.item == 'string'"
              :key="JSON.stringify(newGuid())"
              :selected="data.selected"
              :disabled="data.disabled"
              :outline="!isValidEmail(data.item)"
              :color="!isValidEmail(data.item) ? 'error' : ''"
              close
              class="v-chip--select-multi"
              @click.stop="data.parent.selectedIndex = data.index"
              @input="data.parent.selectItem(data.item)"
            >
              {{ data.item }}           
            </v-chip>

            <v-chip v-else
              :key="JSON.stringify(data.item)"
              :selected="data.selected"
              :disabled="data.disabled"
              close
              class="v-chip--select-multi"
              @click.stop="data.parent.selectedIndex = data.index"
              @input="data.parent.selectItem(data.item)"
            >
              <v-avatar>
                <img :src="getAvatar(data.item.id)" class="avatar-img" />
              </v-avatar>
              {{ data.item.name }}            
            </v-chip>
          </template>

    </v-combobox>
</template>

<script>
    import { mapGetters } from 'vuex';
    import avatarMixin from '@/mixins/avatarMixin';

	const emailRegex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/i;

	export default {
        mixins: [avatarMixin],
        props: {
            value: {
                type: Array,
                default: []
            }
        },
		data() {
			return {
                recipients: this.value,
                search: "",
                recipient: ""
			};
		},
        computed: {
            ...mapGetters({
				employees: 'employees/employeesMiniActiveOnly'
			}),
            employeesMapped() {
                return this.employees.map(employee => {
                    return {
                        id: employee.id,
                        name: employee.fullName,
                        email: employee.email
                    }
                })
            },
            selectedValidRecipients() {
                const validOnly = this.recipients.filter(recipient => {
                    let email;
                    
                    if (typeof recipient == "string") email = recipient;
                    else email = recipient.email;

                    return this.isValidEmail(email);
                });

                return validOnly.map(recipient => {           
                    if (typeof recipient == "string") {
                        return {
                            employeeId: null,
                            name: null,
                            email: recipient
                        }
                    }
                    return {
                        employeeId: recipient.id,
                        name: recipient.name,
                        email: recipient.email
                    }
                })
            }
        },
		methods: {
            updateRecipients() {  
                this.search = "";
                this.$nextTick(() => {
                    this.$emit('input', this.selectedValidRecipients);
                });
            },
            isValidEmail(email) {
                if (!email) return false;
                return emailRegex.test(email);
            },
        }
	};
</script>